// ─── CURSOR ───
const cur = document.getElementById('cur');
if (cur && window.matchMedia('(pointer: fine)').matches) {
  document.addEventListener('mousemove', e => {
    cur.style.left = e.clientX + 'px';
    cur.style.top  = e.clientY + 'px';
  });
  document.querySelectorAll('a, button, input, [data-cursor-grow]').forEach(el => {
    el.addEventListener('mouseenter', () => cur.classList.add('grow'));
    el.addEventListener('mouseleave', () => cur.classList.remove('grow'));
  });
}

// ─── CLOCK ───
const pwClock = document.getElementById('pwClock');
if (pwClock) {
  const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  function tickClock() {
    const n   = new Date();
    const phx = new Date(n.toLocaleString('en-US', { timeZone: 'America/Phoenix' }));
    const h   = String(phx.getHours()).padStart(2, '0');
    const m   = String(phx.getMinutes()).padStart(2, '0');
    const s   = String(phx.getSeconds()).padStart(2, '0');
    pwClock.textContent = `PHX, AZ \u2014 ${months[phx.getMonth()]} ${phx.getDate()} \u2014 ${h}:${m}:${s}`;
  }
  tickClock();
  setInterval(tickClock, 1000);
}

// ─── COUNTDOWN ───
const cdEl   = document.getElementById('pwCountdown');
const liveEl = document.getElementById('pwLive');

if (cdEl && liveEl) {
  const dateStr = cdEl.dataset.targetDate || '2025-04-28';
  const timeStr = cdEl.dataset.targetTime || '10:00';
  const offset  = parseInt(cdEl.dataset.tzOffset || '-7', 10);

  const [year, month, day] = dateStr.split('-').map(Number);
  const [hour, min]        = timeStr.split(':').map(Number);
  const targetMs = Date.UTC(year, month - 1, day, hour - offset, min, 0);

  const cdDays = document.getElementById('cdDays');
  const cdHrs  = document.getElementById('cdHrs');
  const cdMin  = document.getElementById('cdMin');
  const cdSec  = document.getElementById('cdSec');

  function pad(n) { return String(n).padStart(2, '0'); }

  let cdTimer;
  function tickCountdown() {
    const diff = targetMs - Date.now();
    if (diff <= 0) {
      clearInterval(cdTimer);
      cdEl.style.display   = 'none';
      liveEl.style.display = 'flex';
      return;
    }
    const totalSec = Math.floor(diff / 1000);
    cdDays.textContent = pad(Math.floor(totalSec / 86400));
    cdHrs.textContent  = pad(Math.floor(totalSec / 3600) % 24);
    cdMin.textContent  = pad(Math.floor(totalSec / 60) % 60);
    cdSec.textContent  = pad(totalSec % 60);
  }
  tickCountdown();
  cdTimer = setInterval(tickCountdown, 1000);
}

// ─── MODAL HELPERS ───
// Modals start with style="display:none" in HTML so they're never
// visible regardless of CSS load state. JS controls everything.

function openModal(modal, overlay) {
  if (!modal || !overlay) return;

  // Make visible then trigger CSS transition on next frame
  overlay.style.display = 'block';
  modal.style.display   = 'block';

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      overlay.classList.add('open');
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
    });
  });

  document.body.style.overflow = 'hidden';

  // Focus first input if present
  setTimeout(() => {
    const input = modal.querySelector('input');
    if (input) input.focus();
  }, 80);
}

function closeModal(modal, overlay) {
  if (!modal || !overlay) return;

  overlay.classList.remove('open');
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';

  // Re-hide after CSS transition completes (350ms)
  setTimeout(() => {
    if (!modal.classList.contains('open')) {
      modal.style.display   = 'none';
      overlay.style.display = 'none';
    }
  }, 380);
}

// ─── SUCCESS MODAL ───
const successModal   = document.getElementById('pwSuccessModal');
const successOverlay = document.getElementById('pwSuccessOverlay');
const successClose   = document.getElementById('pwSuccessClose');

if (successClose)   successClose.addEventListener('click',   () => closeModal(successModal, successOverlay));
if (successOverlay) successOverlay.addEventListener('click', () => closeModal(successModal, successOverlay));

// Auto-open if server confirmed form posted successfully (non-JS fallback path)
if (document.getElementById('pwFormPosted')) {
  openModal(successModal, successOverlay);
}

// ─── NOTIFY FORM ───
const notifyForm = document.getElementById('pwNotifyForm');
if (notifyForm) {
  notifyForm.addEventListener('submit', async e => {
    e.preventDefault();

    // Validate email before doing anything
    const emailInput = notifyForm.querySelector('input[type="email"]');
    if (emailInput && !emailInput.validity.valid) {
      emailInput.reportValidity();
      return;
    }

    const btn = notifyForm.querySelector('.pw-notify-btn');
    if (btn) { btn.textContent = '...'; btn.disabled = true; }

    // Submit to Shopify in background (optimistic — show success regardless)
    try {
      await fetch('/contact', { method: 'POST', body: new FormData(notifyForm) });
    } catch { /* silent */ }

    // Open success modal
    openModal(successModal, successOverlay);

    // Hide form row so it's clean if user closes and looks back
    const row = document.getElementById('pwNotifyRow');
    if (row) row.style.display = 'none';
  });
}

// ─── PASSWORD MODAL ───
const pwModal        = document.getElementById('pwModal');
const pwModalOverlay = document.getElementById('pwModalOverlay');
const pwHasPwBtn     = document.getElementById('pwHasPwBtn');
const pwModalClose   = document.getElementById('pwModalClose');

if (pwHasPwBtn)     pwHasPwBtn.addEventListener('click',     () => openModal(pwModal, pwModalOverlay));
if (pwModalClose)   pwModalClose.addEventListener('click',   () => closeModal(pwModal, pwModalOverlay));
if (pwModalOverlay) pwModalOverlay.addEventListener('click', () => closeModal(pwModal, pwModalOverlay));

// Close on Escape
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  closeModal(pwModal, pwModalOverlay);
  closeModal(successModal, successOverlay);
});

// Auto-open password modal if wrong code was submitted (server-side error)
if (pwModal && pwModal.querySelector('.pw-modal-error')) {
  openModal(pwModal, pwModalOverlay);
}
